import React from "react";
import MarketingPage from "./MarketingPage";
import { UploadCloud, LayoutTemplate, FileInput, Cpu, CheckCircle2, FileDown } from "lucide-react";

const steps = [
  {icon: UploadCloud, title:"Upload your standards", body:"Add Word templates, formatting requirements, brand guidelines, example documents and writing standards."},
  {icon: LayoutTemplate, title:"Choose what you're creating", body:"Procedures, SWIs, SOPs, maintenance procedures, inspection forms, policies, technical reports or your own custom template."},
  {icon: FileInput, title:"Add your information", body:"Typed notes, DOCX, PDF, TXT, images and supporting files. Combine multiple sources in a single document."},
  {icon: Cpu, title:"Fexidoc structures the document", body:"Reads sources, maps content to your template, applies workspace standards, and flags missing information."},
  {icon: CheckCircle2, title:"Review", body:"Review each section, resolve missing information, regenerate sections or edit directly."},
  {icon: FileDown, title:"Export", body:"Download an editable Microsoft Word document."},
];

export default function HowItWorks() {
  return (
    <MarketingPage eyebrow="How it works" title="Five steps from information to a company-standard document." subtitle="No prompt engineering. Just a structured workflow that respects your existing documentation.">
      <div className="space-y-4">
        {steps.map((s, i) => (
          <div key={s.title} className="fx-panel p-6 grid md:grid-cols-12 items-start gap-6">
            <div className="md:col-span-1 flex items-center gap-2">
              <div className="w-9 h-9 rounded-full bg-gradient-to-br from-[#1478FF] to-[#725BFF] flex items-center justify-center font-display font-bold text-white text-sm">{i+1}</div>
            </div>
            <div className="md:col-span-11">
              <div className="flex items-center gap-3">
                <s.icon size={18} className="text-cyan-300"/>
                <div className="font-display text-lg font-semibold">{s.title}</div>
              </div>
              <div className="mt-2 text-slate-400 leading-relaxed">{s.body}</div>
            </div>
          </div>
        ))}
      </div>
    </MarketingPage>
  );
}
